import React from "react";
import { Form, Select } from "antd";
import { ReactComponent as OutPutIcon } from "@/assets/icons/output.svg";
import { useTranslation } from "react-i18next";
import "@/assets/audioExtractor.less";
import { useState } from "react";
import { useDispatch } from "react-redux";
import action from "../../../../../../redux/action";
import Utils from "../../../../../../utils";
import sendGaEvent from '@/ga'
const { Option } = Select;

const AudioCompressWorkOperationRender = ({ submitting, handleFormat }) => {
  const [value, setValue] = useState("mp3")
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const clickSelect = () => {
    sendGaEvent({
      category: 'vc_referral',
      action: 'AudioExtractor_FormatChoose'
    })
  }

  const openAdvertise = () => {
    dispatch(action.advertiseConfig({
      isShowBtn: false,
      isShowHeader: false,
      headerObj: "",
      percent: 0,
      titleIndex: 1,
      imgIndex: 1,
      source: 'format'
    }));
    dispatch(action.openAdvertiseDialog(true));

  }
  const handleChange = (value) => {


    if (value == 300) {
      sendGaEvent({
        category: 'vc_referral',
        action: 'AudioExtractor_FormatChoose300+'
      })
      openAdvertise();
      setValue("mp3");
      handleFormat("mp3")

    } else {
      setValue(value)
      handleFormat(value)

    }

  }
  return (
    <div className={`step-con ${submitting ? "disabled" : ""}`}>
      <div className="step-header">
        <span className="step-num active">
          <span>2</span>
        </span>
        <div className="step-item">
          <OutPutIcon />
          <span>{t("Select Audio Format")}</span>
        </div>
      </div>
      <div className="step-cont">
        <Form>
          <Form.Item label={t("audioExtractor:Format")}>
            <Select onClick={() => clickSelect()} value={value} autoClearSearchValue style={{ width: 160 }} onChange={handleChange}>
              <Option value="wav">WAV</Option>
              <Option value="mp3">MP3</Option>
              <Option value="m4a">M4A</Option>
              <Option value="aac">AAC</Option>
              <Option value="ogg">OGG</Option>
              {Utils.getSystemType() != "other" ? <Option value="300">{t('advertise:300Formats')}</Option> : null}

            </Select>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default AudioCompressWorkOperationRender;
